import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseHeaderTitle } from '~/components/common';
import InvoiceList from '~/components/invoices/InvoiceList/InvoiceList';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { handleGetInvoices } from '~/thunks/invoice/invoiceThunk';
import { handleApiError } from '~/utils/helper';

const Invoice = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/invoice', 'admin/component']);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook
  //#region Selector
  const { filter, needRefreshData } = useAppSelector((state) => state.invoice);
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    dispatch(handleGetInvoices(filter))
      .unwrap()
      .catch((e) => {
        handleApiError(e);
      });
  }, [dispatch, filter, needRefreshData]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
  return (
    <>
      <Box className='w-full h-full mb-[40px]'>
        <Box className='flex flex-col mb-[40px]'>
          <BaseHeaderTitle title={t('invoiceTitle')} />
        </Box>
        <Box>
          <InvoiceList isHideMenu={true} />
        </Box>
      </Box>
    </>
  );
};

export default Invoice;
